import { useState, useEffect } from "react";
import stl from "./Pagination.module.css";
import useHelpers from "@hooks/useHelpers";
import {CDN_LINK} from "@globalConfig";

const Pagination = ({
  pageCount,
  currentPage
}) => {
  const {createUrl} = useHelpers();
  const [activePage, setActivePage] = useState(+currentPage);
  // 2 : number of pages to show
  const [pagesToShow, setPagesToShow] = useState(
    [...Array(pageCount)].map((_, i) => i + 1).splice(currentPage - 1, 2)
  );

  const arrayOfPages = [...Array(pageCount)].map((_, i) => i + 1);

  useEffect(() => {
    const activePageIndex = pagesToShow.indexOf(activePage);
    if (activePageIndex >= pagesToShow.length - 2) {
      const arrayOfPagesCopy = [...arrayOfPages];
      setPagesToShow(arrayOfPagesCopy.splice(activePage - 1, 2));
    }
  }, [activePage]);
  return (
    <div className={`${stl.pagination} ${stl.trendingContainer}`}>
      <a
        className={[
          stl.prev,
          stl.trendingPrev,
          currentPage === 1 ? stl.disabled : "",
        ].join(" ")}
        disabled={currentPage === 1}
        href={createUrl( currentPage === 1 || currentPage === 2 ? `/trend` : `/trend?page=${currentPage - 1}`)}
      >
        <img
          src={
            currentPage === 1
              ? CDN_LINK+"/assets/images/pagination/disabled_arrow.svg"
              : CDN_LINK+"/assets/images/pagination/arrow.svg"
          }
          loading="lazy"
          alt="arrow"
          width={24}
          height={24}
        />
      </a>
      <div className={stl.pagesNumContainer}>
        {activePage >= pageCount - 2 && pageCount - 3 > 0 && (
          <a
            className={`
               ${stl.pagesNum}
              `}
            href={createUrl(`/trend`)}
          >
            1
          </a>
        )}
        {activePage >= pageCount - 2 && pageCount - 3 > 0 && (
          <button className={stl.pagesNum}>
            ...
          </button>
        )}
        {/* "the before last page" edge case */}
        {activePage >= pageCount - 1 && pageCount - 2 > 0 && (
          <a
            className={`
               ${stl.pagesNum}
              `}
            href={createUrl(`/trend?page=${pageCount - 2}`)}
          >
            {pageCount - 2}
          </a>
        )}
        {/* end of the "the before last page" edge case */}
        {/* last page edge case */}
        {activePage === pageCount && pageCount - 1 > 0 && (
          <a
            className={`
               ${stl.pagesNum}
              `}
            href={createUrl(activePage - 1 == 1 ? `/trend` : `/trend?page=${activePage - 1}`)}
          >
            {activePage - 1}
          </a>
        )}
        {/* end of the last page edge case */}
        {/* mapping */}
        {pagesToShow
          .filter((item) => item !== pageCount)
          .map((item) => {
            return (
              <a
                key={item}
                className={`${activePage === item ? stl.activeTrending : ""} ${
                  stl.pagesNum
                }`}
                href={createUrl(
                  `/trend${item !== 1 ? `?page=${item}` : ""}`
                )}
              >
                {item}
              </a>
            );
          })}
        {activePage < pageCount - 3 && (
          <button
            className={`
           ${stl.pagesNum}
          `}
          >
            ...
          </button>
        )}
        {/* the button of the last page */}
        <a
          className={`
           ${activePage === pageCount ? stl.activeTrending : ""} ${stl.pagesNum}
          `}
          href={createUrl(`/trend?page=${pageCount}`)}
        >
          {pageCount}
        </a>
      </div>

      <a
        className={[
          stl.next,
          stl.trendingNext,
          currentPage === pageCount ? stl.disabled : "",
        ].join(" ")}
        disabled={currentPage === pageCount}
        href={createUrl(`/trend?page=${currentPage + 1}`)}
      >
        <img
          src={
            currentPage === pageCount
              ? CDN_LINK+"/assets/images/pagination/disabled_arrow.svg"
              : CDN_LINK+"/assets/images/pagination/arrow.svg"
          }
          alt="arrow"
          loading="lazy"
          width={24}
          height={24}
        />
      </a>
    </div>
  );
};

export default Pagination;
